import React from 'react';
import { AutomationStats } from '../../types/automatisation.types';
import {
  ChartBarIcon,
  ClockIcon,
  CheckCircleIcon,
  XCircleIcon
} from '@heroicons/react/24/outline';
import './AutomatisationStats.css';

interface AutomatisationStatsProps {
  stats: AutomationStats;
  loading?: boolean;
}

export const AutomatisationStats: React.FC<AutomatisationStatsProps> = ({
  stats,
  loading = false
}) => {
  const successRate = stats.executions.total_executions > 0
    ? Math.round((stats.executions.successful_executions / stats.executions.total_executions) * 100)
    : 0;

  return (
    <div className="admin-automatisation-stats">
      <div className="admin-automatisation-stats-card">
        <div className="admin-automatisation-stats-icon-wrapper bg-blue-100">
          <ClockIcon className="admin-automatisation-stats-icon text-blue-600" />
        </div>
        <div className="admin-automatisation-stats-content">
          <p className="admin-automatisation-stats-label">Automatisations actives</p>
          <p className="admin-automatisation-stats-value">
            {loading ? '...' : stats.automations.active_count}
            <span className="admin-automatisation-stats-total">
              / {stats.automations.total_count}
            </span>
          </p>
        </div>
      </div>

      <div className="admin-automatisation-stats-card">
        <div className="admin-automatisation-stats-icon-wrapper bg-green-100">
          <CheckCircleIcon className="admin-automatisation-stats-icon text-green-600" />
        </div>
        <div className="admin-automatisation-stats-content">
          <p className="admin-automatisation-stats-label">Exécutions réussies</p>
          <p className="admin-automatisation-stats-value">
            {loading ? '...' : stats.executions.successful_executions}
            <span className="admin-automatisation-stats-percentage text-green-600">
              ({successRate}%)
            </span>
          </p>
        </div>
      </div>

      <div className="admin-automatisation-stats-card">
        <div className="admin-automatisation-stats-icon-wrapper bg-yellow-100">
          <ChartBarIcon className="admin-automatisation-stats-icon text-yellow-600" />
        </div>
        <div className="admin-automatisation-stats-content">
          <p className="admin-automatisation-stats-label">Total exécutions</p>
          <p className="admin-automatisation-stats-value">
            {loading ? '...' : stats.executions.total_executions}
          </p>
        </div>
      </div>

      {stats.executions.failed_executions > 0 && (
        <div className="admin-automatisation-stats-card">
          <div className="admin-automatisation-stats-icon-wrapper bg-red-100">
            <XCircleIcon className="admin-automatisation-stats-icon text-red-600" />
          </div>
          <div className="admin-automatisation-stats-content">
            <p className="admin-automatisation-stats-label">Échecs</p>
            <p className="admin-automatisation-stats-value text-red-600">
              {stats.executions.failed_executions}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};